import React from 'react';
import PropTypes from 'prop-types';
import { Numeric } from 'components/formatting';
import './Panel.css';
import classNames from 'classnames';

export function StatPanel({
    title,
    value,
    loading = false
}) {
    return (
        <div className='stat-panel'>
            <div className={classNames("spacer-bottom-small", {"bp6-skeleton": loading})}>{title}</div>
            <span className={classNames("stat-panel-counter", {"bp6-skeleton": loading})}><Numeric>{value}</Numeric></span>
        </div>
    );
}

StatPanel.propTypes = {
    title: PropTypes.string,
    value: PropTypes.number,
    loading: PropTypes.bool
};